import { fetchTabs } from "@/lib/storyblok/storyblokServerFunctions";
import { ProductGalleryWithTabsStoryblokExtended } from "@/types/addtional-types";
import TabsUI from "../atoms/TabsUI/TabsUI";

const ProductGalleryWithTabs = ({
  blok,
  data,
  preview
}: {
  blok: ProductGalleryWithTabsStoryblokExtended;
  data: Awaited<ReturnType<typeof fetchTabs>>;
  preview: boolean;
}) => {
  return <TabsUI title={blok.Title} tabsData={data} preview={preview} />;
};

export default ProductGalleryWithTabs;
